export const isPlanAvailable = plan => {
  return (
    plan?.isOnStock === 'available' ||
    (plan?.isOnStock === 'automatic' && plan?.classifications.some(c => c?.isOnStock))
  );
};
